import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { useTheme, css } from 'styled-components'
import contextStandardTeaser from '@contexts/standardTeaser'
import { StandardTeaserLayoutContextType } from '@contexts/standardTeaser'
import SvgIcon from '@components/SvgIcon'

type StyledVideoInfoProps = Pick<StandardTeaserLayoutContextType, 'isVideoOnly'>
type StyledVideoIconWrapperProps = Pick<
  StandardTeaserLayoutContextType,
  'isVideoOnly'
>
type StyledVideoDurationProps = Pick<
  StandardTeaserLayoutContextType,
  'isVideoOnly'
>

const { StandardTeaserLayoutContext } = contextStandardTeaser

const StyledVideoInfo = styled.div<StyledVideoInfoProps>`
  ${({ isVideoOnly }) => {
    const basicCSS = css`
      position: relative;
    `
    if (isVideoOnly) {
      return css`
        ${basicCSS}
      `
    } else {
      return css`
        ${basicCSS}
        padding-left: 19px;
      `
    }
  }}
`

const StyledVideoIconWrapper = styled.div<StyledVideoIconWrapperProps>`
  ${({
    theme: {
      colors: {
        brandColors: { brand_55 },
      },
    },
    isVideoOnly,
  }) => {
    if (isVideoOnly) {
      return css`
        display: none;
      `
    } else {
      return css`
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        line-height: 0;
        padding: 0px;
        background-color: ${brand_55};
      `
    }
  }};
`

const StyledVideoDuration = styled.div<StyledVideoDurationProps>`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        white,
        blicktvGrey: { btvGrey_100 },
      },
    },
    isVideoOnly,
  }) => {
    const basicCSS = css`
      background-color: ${btvGrey_100};
      color: ${white};
      font-size: 14px;
      line-height: 19px;
      padding: 0 3px;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
      font-family: ${sourceSansPro};
    `

    if (isVideoOnly) {
      return css`
        ${basicCSS};
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
      `
    } else {
      return css`
        ${basicCSS};
      `
    }
  }};
`

const VideoInfo: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { isVideoOnly } = useContext(StandardTeaserLayoutContext)
  const theme = useTheme()

  return (
    <StyledVideoInfo isVideoOnly={isVideoOnly}>
      <StyledVideoIconWrapper isVideoOnly={isVideoOnly}>
        <SvgIcon iconName="video-play" size={19} color={theme.colors.white} />
      </StyledVideoIconWrapper>
      <StyledVideoDuration isVideoOnly={isVideoOnly}>
        {children}
      </StyledVideoDuration>
    </StyledVideoInfo>
  )
}

export default VideoInfo
